import React from 'react';
import s from './PROActive.css';
import withStyles from "isomorphic-style-loader/withStyles";
import Grid from "@material-ui/core/Grid/index";
import Container from "@material-ui/core/Container/index";
import Plan from "../../../components/Plan/Plan";
import getUser from '../../../utils/getUser';
import HeadMessage from "../../../components/Common/HeadMessage/HeadMessage";
import Email from "../../../components/Email/Email";

class PROActive extends React.Component {
    constructor(props) {
        super(props);
    }

    cancel() {
        if (confirm('Are you sure you want to cancel the subscription?')) {
            window.open(this.props.subscription.cancelUrl, '_blank');
        }
    }

    update() {
        window.open(this.props.subscription.updateUrl, '_blank');
    }

    render() {
        const user = getUser();

        return (
            <div>
                <HeadMessage>
                    <h1>PRO <span>is active</span></h1>
                    <h5>You can update or cancel your subscription</h5>
                </HeadMessage>

                <Container maxWidth="md" style={{ textAlign: 'center' }}>
                    <Grid container>
                        <Grid item xs={12} md={2}/>

                        <Grid item xs={12} md={4}>
                            <Plan
                                onClick={() => { this.cancel(); }}
                                header={'Cancel'}
                                price={' '}
                                style={{ border: '2px solid #FFF' }}
                                buttonText={'Cancel subscription'}
                                color={'secondary'}
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Plan
                                onClick={() => { this.update(); }}
                                header={<span>Payment info</span>}
                                price={' '}
                                style={{ border: '2px solid #1EC3F8' }}
                                buttonText={'Update payment info'}
                            />
                        </Grid>
                    </Grid>


                    <div className={s.space}/>

                    <div>
                       Feel free to write me: <Email/>
                    </div>
                </Container>
            </div>
        );
    }
}

export default withStyles(s)(PROActive);